export default "__VITE_ASSET__198e5c03__"